import { useContext } from 'react';
import type { FormState } from '@gonfalon/legacy-forms/formUtils';
import { FormContext } from '@gonfalon/legacy-forms/formUtils';
import { BrandArrow } from '@gonfalon/ui/BrandArrow';
import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

export type SubmitButtonProps = Omit<ButtonProps, 'Kind'> & {
  kind?: 'primary' | 'destructive';

  // SubmitButton does not care or know about the type form state.
  // oxlint-disable-next-line typescript/no-explicit-any
  formState?: FormState<any>;
  loadingText?: string;
  /**
   * Opt in to the trailing brand arrow. Off by default, so the many legacy forms
   * backed by this button are untouched — reserve it for high-intent, forward-motion
   * CTAs. See `BrandArrow`.
   */
  withBrandArrow?: boolean;
};

export function SubmitButton(props: SubmitButtonProps) {
  const {
    kind = 'primary',
    formState: formStateProp,
    isDisabled,
    children,
    loadingText,
    withBrandArrow = false,
    ...other
  } = props;

  const formState = useContext(FormContext)?.formState || formStateProp;
  const loading = formState?.isFormSubmitting();
  const text = loading ? loadingText : children;
  let shouldDisable = !formState?.canSubmitForm();
  if (isDisabled !== null && typeof isDisabled !== 'undefined') {
    shouldDisable = loading || isDisabled;
  }

  const showBrandArrow = withBrandArrow && kind === 'primary';

  return (
    <Button type="submit" {...other} isPending={loading} variant={kind} isDisabled={shouldDisable}>
      {showBrandArrow ? (
        <>
          {text}
          <BrandArrow />
        </>
      ) : (
        text
      )}
    </Button>
  );
}
